import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";

import {
  getServiceFromState,
  getServiceCoursesFromState,
} from "features/competence.selectors";

import ServiceItemList from "features/service/components/ServiceItemList";

const ServiceCourseListContainer = props => {
  const { serviceCourses } = props;

  return !serviceCourses.size ? null : (
    <ServiceItemList items={serviceCourses} {...props} />
  );
};

export default compose(
  connect(
    (state, { serviceId }) => ({
      service: getServiceFromState(state, serviceId),
      serviceCourses: getServiceCoursesFromState(state, serviceId),
    }),
    null,
  ),
)(ServiceCourseListContainer);
